import {UserOPEEnum} from "../UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {TimeUnitEnum} from "../../../enums/dashboard/TimeUnitEnum";
import {TypeOfDateSettingsEnumCharts} from "../../../enums/dashboard/TypeOfDateSettingsEnumCharts";
import {BucketUnitEnum} from "../../../enums/dashboard/ChartsEnum";

class O {
  id!: number;
}

export class UserMetricDTO {
  id!: number;
  functionType?: string;
  color?: string;
  chartType?: string;
}

export class TimeIntervalDTO {
  startDate!: number;
  endDate!: number;
  selectedDateSettings!: TypeOfDateSettingsEnumCharts;
  realTimeUnit!: TimeUnitEnum;
  realtimeValue!: number;
}

/**
 * O Inner Class
 */
class I {
  id?: number;
  name!: string;
  bucketUnits?: BucketUnitEnum;
  bucketValue?: number;
  metrics!: UserMetricDTO[];
  timeInterval!: TimeIntervalDTO;

  constructor() {
    this.metrics = [];
  }
}


/**
 * GetTransportItemDetailCB class
 */
export class PutUserMetricGroupCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.PutUserMetricGroup);
    this.i = new I();
    this.o = new O();
  }

}
